export default __webpack_public_path__ + "static/report-filtered-period-f4f3141b13dda90cae368f5a0faf3e3b.mp4";